import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DefaultLayout from './layouts/DefaultLayout';
import SimpleLayout from './layouts/SimpleLayout';
import Home from './components/Home';
import Signup from './components/Signup';
import AboutUs from './components/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy'
import TermsOfService from './components/TermsOfService'
import BlogPage from './components/BlogPage';
import PostPage from './components/PostPage';
import ChangeLog from './components/ChangeLog';
import DataErasure from './components/DataErasure';
import './index.css'; // or './App.css' depending on your setup




function App() {
  
  return (
    <div className="App">
    <Router>
      <Routes>
        {/* Routes using DefaultLayout */}
        <Route
          path="/"
          element={
            <DefaultLayout>
              <Home />
            </DefaultLayout>
          }
        />
         <Route
          path="about-us"
          element={
            <DefaultLayout>
              <AboutUs />
            </DefaultLayout>
          }
        />
        <Route
          path="blog"
          element={
            <DefaultLayout>
              <BlogPage />
            </DefaultLayout>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <DefaultLayout>
              <PostPage />
            </DefaultLayout>
          }
        />
        <Route
          path="privacy-policy"
          element={
            <DefaultLayout>
              <PrivacyPolicy />
            </DefaultLayout>
          }
        />
        <Route
          path="terms-of-service"
          element={
            <DefaultLayout>
              <TermsOfService />
            </DefaultLayout>
          }
        />
        <Route
          path="changelog"
          element={
            <DefaultLayout>
              <ChangeLog />
            </DefaultLayout>
          }
        />
        {/* Secondary landing page: Furloop Poofed — verified data erasure */}
        <Route
          path="data-erasure"
          element={
            <DefaultLayout>
              <DataErasure />
            </DefaultLayout>
          }
        />
        <Route
          path="poofed"
          element={
            <DefaultLayout>
              <DataErasure />
            </DefaultLayout>
          }
        />
       {/* <Route
          path="/iso-app"
          element={
            <DefaultLayout>
              <ISOApp />
            </DefaultLayout>
          }
        />
        <Route
          path="/pricing"
          element={
            <DefaultLayout>
              <Pricing />
            </DefaultLayout>
          }
        /> */}

        {/* Routes using SimpleLayout */}
        <Route
          path="/sign-up-today"
          element={
                <SimpleLayout>
                  <Signup />
                </SimpleLayout>
           }
        />


      </Routes> 
    </Router>
 </div>
  );
}



export default App;
